/* Vanille Desire · « Prevenez-moi du retour »
 *
 * Une seule fenetre par page (snippets/vd-back-in-stock.liquid). Chaque carte
 * epuisee porte un bouton [data-vd-bis-open] avec le handle et le titre du
 * produit. A l'ouverture on pose l'etiquette « retour-<handle> » dans le champ
 * cache du formulaire client Shopify. Sans JavaScript le bouton reste un lien
 * vers la fiche produit : rien ne casse.
 *
 * POURQUOI UN ENVOI CLASSIQUE ET PAS UN FETCH.
 * La protection anti-robot de Shopify (script « captcha-bootstrap », injecte
 * dans le <head> de la boutique) surveille les formulaires
 * form[action*='/contact'] dont form_type vaut « customer ». Elle ne se lie au
 * formulaire qu'apres un evenement focusin ou change, puis intercepte l'envoi
 * pour y coller son jeton. Un POST fabrique a la main par fetch n'a pas ce
 * jeton : le serveur repond 400 « Missing CAPTCHA token » (verifie le 04/09).
 * On laisse donc partir l'envoi natif ; la page revient sur l'URL de
 * return_to avec ?bis=ok, et on rouvre la fenetre sur le message de
 * confirmation. Ouvrir la fenetre met le focus dans le champ, ce qui declenche
 * la liaison du captcha avant meme que le client ait tape son adresse.
 */
(function () {
  'use strict';

  var PREFIXE = 'retour-';
  var CLE = 'vd-bis-encours';
  var pret = false;

  function init() {
    var boite = document.querySelector('[data-vd-bis]');
    if (!boite || pret) return;
    pret = true;

    /* Les cartes creent un contexte d'empilement (isolation: isolate) : la
       fenetre doit vivre directement sous <body> pour passer au-dessus de
       tout, quelle que soit sa position dans la grille. */
    if (boite.parentNode !== document.body) document.body.appendChild(boite);

    var form = boite.querySelector('form');
    var champTags = boite.querySelector('[data-vd-bis-tags]');
    var champRetour = boite.querySelector('[name="return_to"]');
    var champMail = boite.querySelector('#VdBisEmail');
    var titre = boite.querySelector('[data-vd-bis-title]');
    var msg = boite.querySelector('[data-vd-bis-msg]');
    var envoi = boite.querySelector('[data-vd-bis-submit]');
    var declencheur = null;

    function memoire() {
      try {
        return window.sessionStorage;
      } catch (e) {
        return null;
      }
    }

    function afficher(texte, erreur) {
      if (!msg) return;
      msg.textContent = texte;
      msg.classList.toggle('vd-bis__msg--error', !!erreur);
      msg.hidden = false;
    }

    function cacher() {
      if (!msg) return;
      msg.hidden = true;
      msg.textContent = '';
      msg.classList.remove('vd-bis__msg--error');
    }

    function verrouillerPage(oui) {
      document.documentElement.style.overflow = oui ? 'hidden' : '';
    }

    function ouvrir(bouton) {
      var handle = bouton.getAttribute('data-vd-bis-handle') || '';
      var nom = bouton.getAttribute('data-vd-bis-produit') || '';
      if (!handle) return false;
      declencheur = bouton;
      boite.classList.remove('is-done');
      cacher();
      if (form) form.reset();
      /* reset() vide aussi les champs caches : on les repose apres. */
      if (champTags) champTags.value = PREFIXE + handle;
      if (champRetour) champRetour.value = location.pathname + '?bis=ok';
      if (titre) titre.textContent = nom;
      if (envoi) envoi.disabled = false;
      boite.hidden = false;
      verrouillerPage(true);
      if (champMail) {
        try {
          champMail.focus({ preventScroll: true });
        } catch (e) {
          champMail.focus();
        }
        /* La protection anti-robot de Shopify ne se lie au formulaire qu'au
           premier focusin ou change. On l'emet explicitement : un focus()
           dans un onglet en arriere-plan n'en produit pas toujours, et sans
           liaison le premier envoi est annule en silence. */
        try {
          champMail.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
        } catch (e) {
          try {
            var ev = document.createEvent('Event');
            ev.initEvent('focusin', true, false);
            champMail.dispatchEvent(ev);
          } catch (e2) {}
        }
      }
      return true;
    }

    function fermer() {
      boite.hidden = true;
      verrouillerPage(false);
      if (declencheur) {
        try {
          declencheur.focus({ preventScroll: true });
        } catch (e) {}
        declencheur = null;
      }
    }

    /* Retour d'envoi : la page a ete rechargee par Shopify. */
    function confirmer() {
      var q = location.search || '';
      var marque = q.indexOf('bis=ok') !== -1;
      var poste = q.indexOf('customer_posted=true') !== -1;
      if (!marque && !poste) return;
      var m = memoire();
      var nom = '';
      if (m) {
        nom = m.getItem(CLE) || '';
        m.removeItem(CLE);
      }
      /* customer_posted=true peut venir d'un autre formulaire de la page :
         on ne confirme alors que si c'est bien nous qui avons envoye. */
      if (!marque && !nom) return;
      if (titre) titre.textContent = nom;
      boite.classList.add('is-done');
      afficher(boite.getAttribute('data-msg-ok') || '', false);
      boite.hidden = false;
      verrouillerPage(true);
      /* On retire nos marqueurs de l'URL sans toucher au reste. */
      try {
        var p = new URLSearchParams(location.search);
        p.delete('bis');
        p.delete('customer_posted');
        p.delete('form_type');
        var reste = p.toString();
        history.replaceState({}, '', location.pathname + (reste ? '?' + reste : ''));
      } catch (e) {}
    }

    document.addEventListener('click', function (ev) {
      var bouton = ev.target.closest ? ev.target.closest('[data-vd-bis-open]') : null;
      if (bouton) {
        if (ouvrir(bouton)) ev.preventDefault();
        return;
      }
      if (ev.target.closest && ev.target.closest('[data-vd-bis-close]')) {
        ev.preventDefault();
        fermer();
      }
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !boite.hidden) fermer();
    });

    /* Piege a tabulation minimal : on garde le focus dans la fenetre. */
    boite.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Tab' || boite.hidden) return;
      var cibles = boite.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])');
      if (!cibles.length) return;
      var premier = cibles[0];
      var dernier = cibles[cibles.length - 1];
      if (ev.shiftKey && document.activeElement === premier) {
        ev.preventDefault();
        dernier.focus();
      } else if (!ev.shiftKey && document.activeElement === dernier) {
        ev.preventDefault();
        premier.focus();
      }
    });

    if (form) {
      form.addEventListener('submit', function () {
        /* Envoi natif : on ne l'empeche pas, la protection anti-robot doit
           pouvoir l'intercepter. On garde seulement de quoi rouvrir la
           fenetre sur la confirmation au retour. */
        var m = memoire();
        if (m && titre) {
          try {
            m.setItem(CLE, titre.textContent || '');
          } catch (e) {}
        }
        if (envoi) envoi.disabled = true;
        /* Filet : si la protection anti-robot bloque l'envoi en silence, le
           bouton ne doit pas rester mort. */
        setTimeout(function () {
          if (envoi) envoi.disabled = false;
        }, 6000);
      });
    }

    confirmer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
